import { createContext } from 'react';
import { noop } from 'lodash';
import { TranslationState } from '../../hooks/useTranslationToggle.types';

export const UGCContext = createContext<{
    ugcMap: Record<string, any>;
    showTranslatedContent: boolean;
    addUgcData: (state: TranslationState['ugcMap']) => void;
    showTranslatedContentRef: React.MutableRefObject<boolean>;
}>({
    ugcMap: {},
    showTranslatedContent: false,
    addUgcData: noop,
    showTranslatedContentRef: { current: false },
});
